const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "PHONE_COUNTRY_CODES_RETRIEVED":
            return action.phoneCountryCodes;

        default:
            return state;
    }
}
